module.exports = __webpack_public_path__ + "img/HQ-PA2W1CL-T.0910b1aa.jpg";